<div class="left">
  <div class="header-container">
    <a class="logo" href="#">
      <h2 class="text-primary">
        <img src="../../../../assets/images/24.png" alt="MP Fenix logo">
      </h2>
    </a>
  </div>
</div>



<div class="right">
  <nb-actions size="small">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user 
        [nbContextMenu]="userMenu"
        [nbContextMenuTag]="'user-menu'"
        [onlyPicture]="userPictureOnly"
        [name]="''"
        [picture]="'assets/images/user-icon.png'">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
